export const SET_CAMPAIGNS = 'SET_CAMPAIGNS'

export default {
  [SET_CAMPAIGNS](state, campaigns) {
    Object.assign(state, { campaigns })
  },
}
